<template>
  <ag-grid-vue
    ref="elementRef"
    :class="this.props.className"
    :style="this.props.style"
    :columnDefs="columns"
    :rowData="model[modelKey]"
    :deltaRowDataMode="model[modelKey]"
    :singleClickEdit="this.props.singleClickEdit"
    :editType="this.props.editType"
    :enableCellChangeFlash="this.props.enableCellChangeFlash"
    :stopEditingWhenGridLosesFocus="this.props.stopEditingWhenGridLosesFocus"
    :components="components"

    @cellClicked="this.cellClicked"
    @cellDoubleClicked="this.cellDoubleClicked"
    @rowClicked="this.rowClicked"
    @rowDoubleClicked="this.rowDoubleClicked"
    @cellValueChanged="this.cellValueChanged"
    @rowValueChanged="this.rowValueChanged"
    @cellEditingStarted="this.cellEditingStarted"
    @cellEditingStopped="this.cellEditingStopped"
    @rowEditingStarted="this.rowEditingStarted"
    @rowEditingStopped="this.rowEditingStopped"
  ></ag-grid-vue>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import CommonUtil from "../../util/CommonUtil";
import ModelUtil from "../../util/ModelUtil";
import ExpressionUtil from "../../util/ExpressionUtil";

export default {
  name: "GridComponent",
  components: {
    AgGridVue
  },
  props: ["elementIndex", "props", "displayData", "detailList"],
  beforeMount: function() {
    // ClassName
    if (this.props.className == null) this.$set(this.props, "className", "ag-theme-balham");
    // 样式
    if (this.props.style == null) this.$set(this.props, "style", "height:331px");
    // 单击编辑
    if (this.props.singleClickEdit == null) this.$set(this.props, "singleClickEdit", true);
    // 编辑方式
    if (this.props.editType == null) this.$set(this.props, "editType", "fullRow");
    // 表格数据连动
    if (this.props.enableCellChangeFlash == null) this.$set(this.props, "enableCellChangeFlash", true);
    // 焦点离开完成编辑
    if (this.props.stopEditingWhenGridLosesFocus == null) this.$set(this.props, "stopEditingWhenGridLosesFocus", true);
  },
  mounted: function() {
    // 保存控件实例
    CommonUtil.saveElementToStore(this);
  },
  computed: {
    tableloading: function() {
      // 设置输入框为只读
      return this.$store.getters.isLoading || this.props.loading;
    },
    model: function() {
      return ModelUtil.getModelObject(this, this.displayData);
    },
    modelKey: function() {
      return ModelUtil.getModelKey(this, this.displayData, []);
    },
    columns: function() {
      var tableColumn = new Array();
      if (this.detailList) {
        for (let i = 0; i < this.detailList.length; i++) {
          var columnDetail = this.detailList[i];

          // 列属性
          var columnProp = {};
          if (columnDetail.detailProp) {
            columnProp = JSON.parse(columnDetail.detailProp);
          }
          columnProp.headerName = columnDetail.detailName;
          columnProp.field = columnDetail.displayData;

          columnProp.valueFormatter = currencyFormatter;
          columnProp.cellEditorParams = {
            vue : this,
            rowData : this.model[this.modelKey]
          };

          if (columnDetail.displayType == "select") {
            let detailDisplayProp = JSON.parse(columnDetail.displayProp);

            let valueKey = "0";
            let labelKey = "1";

            if (detailDisplayProp.valueKey) {
              valueKey = detailDisplayProp.valueKey;
            }
            if (detailDisplayProp.labelKey) {
              labelKey = detailDisplayProp.labelKey;
            }

            columnProp.cellEditor = "agSelectCellEditor";
            columnProp.cellEditorParams.values = [""];
            columnProp.cellEditorParams.labels = {};
            
            var opOptions = [];
            if (typeof detailDisplayProp.options == "string") {
              // 动态选项
              opOptions = ExpressionUtil.createObject(this, detailDisplayProp.options);
              if (Array.isArray(opOptions) == false) {
                opOptions = [];
              }
            } else {
              // 固定选项
              opOptions = detailDisplayProp.options;
            }

            for (let j=0;j<opOptions.length;j++) {
              columnProp.cellEditorParams.values.push(opOptions[j][valueKey]);
              columnProp.cellEditorParams.labels[opOptions[j][valueKey]] = opOptions[j][labelKey];
            }
          }
          
          if (columnDetail.displayType == "number") {
            columnProp.cellEditor = "numericCellEditor";
          }
          
          if (columnDetail.displayType == "icon") {
            let detailDisplayProp = JSON.parse(columnDetail.displayProp);

            columnProp.cellRenderer = "iconRenderer";
            columnProp.cellEditorParams.onClick = detailDisplayProp.onClick;
          }

          tableColumn.push(columnProp);
        }
      }
      return tableColumn;
    },
    components: function() {
      return {
        numericCellEditor: getNumericCellEditor(),
        iconRenderer: iconRenderer
      };
    }
  },
  methods: {
    cellClicked: function(param) {
      if (this.props.cellClicked) {
        ExpressionUtil.eval(this, this.props.cellClicked, param.data, param.value);
      }
    },
    cellDoubleClicked: function(param) {
      if (this.props.cellDoubleClicked) {
        ExpressionUtil.eval(this, this.props.cellDoubleClicked, param.data, param.value);
      }
    },
    rowClicked: function(param) {
      if (this.props.rowClicked) {
        ExpressionUtil.eval(this, this.props.rowClicked, param.data);
      }
    },
    rowDoubleClicked: function(param) {
      if (this.props.rowDoubleClicked) {
        ExpressionUtil.eval(this, this.props.rowDoubleClicked, param.data);
      }
    },
    cellValueChanged: function(param) {
      if (this.props.cellValueChanged) {
        ExpressionUtil.eval(this, this.props.cellValueChanged, param.data, param.newValue, param.oldValue);
      }
    },
    rowValueChanged: function(param) {
      if (this.props.rowValueChanged) {
        ExpressionUtil.eval(this, this.props.rowValueChanged, param.data);
      }
    },
    cellEditingStarted: function(param) {
      if (this.props.cellEditingStarted) {
        ExpressionUtil.eval(this, this.props.cellEditingStarted, param.data, param.value);
      }
    },
    cellEditingStopped: function(param) {
      if (this.props.cellEditingStopped) {
        ExpressionUtil.eval(this, this.props.cellEditingStopped, param.data, param.value);
      }
    },
    rowEditingStarted: function(param) {
      if (this.props.rowEditingStarted) {
        ExpressionUtil.eval(this, this.props.rowEditingStarted, param.data);
      }
    },
    rowEditingStopped: function(param) {
      if (this.props.rowEditingStopped) {
        ExpressionUtil.eval(this, this.props.rowEditingStopped, param.data);
      }
    },
  }
};

function currencyFormatter(params) {
  if (params.value) {
    if (params.colDef.cellEditorParams.labels) {
      return params.colDef.cellEditorParams.labels[params.value];
    } else {
      return params.value;
    }
  } else {
    return "";
  }
}

function getNumericCellEditor() {
  function isCharNumeric(charStr) {
    return !!/\d/.test(charStr);
  }
  function isKeyPressedNumeric(event) {
    var charCode = getCharCodeFromEvent(event);
    var charStr = String.fromCharCode(charCode);
    return isCharNumeric(charStr);
  }
  function getCharCodeFromEvent(event) {
    event = event || window.event;
    return typeof event.which === "undefined" ? event.keyCode : event.which;
  }
  function NumericCellEditor() {}
  NumericCellEditor.prototype.init = function(params) {
    if (!params.value) {
      params.value = "";
    }

    this.focusAfterAttached = params.cellStartedEdit;
    this.eInput = document.createElement("input");
    this.eInput.style.width = "100%";
    this.eInput.style.height = "100%";
    this.eInput.value = isCharNumeric(params.charPress) ? params.charPress : params.value;
    var that = this;
    this.eInput.addEventListener("keypress", function(event) {
      if (!isKeyPressedNumeric(event)) {
        that.eInput.focus();
        if (event.preventDefault) event.preventDefault();
      }
    });
  };
  NumericCellEditor.prototype.getGui = function() {
    return this.eInput;
  };
  NumericCellEditor.prototype.afterGuiAttached = function() {
    if (this.focusAfterAttached) {
      this.eInput.focus();
      this.eInput.select();
    }
  };
  NumericCellEditor.prototype.isCancelBeforeStart = function() {
    return this.cancelBeforeStart;
  };
  NumericCellEditor.prototype.isCancelAfterEnd = function() {};
  NumericCellEditor.prototype.getValue = function() {
    if (this.eInput.value) {
      return this.eInput.value;
    } else {
      return "";
    }
  };
  NumericCellEditor.prototype.focusIn = function() {
    var eInput = this.getGui();
    eInput.focus();
    eInput.select();
    console.log("NumericCellEditor.focusIn()");
  };
  NumericCellEditor.prototype.focusOut = function() {
    console.log("NumericCellEditor.focusOut()");
  };
  return NumericCellEditor;
}

function iconRenderer(params) {
    var icon = params.colDef.field;

    var element = document.createElement("i");
    if (icon.startsWith("md-") && icon.startsWith("md-")) {
      element.className = "ivu-icon ivu-icon-" + icon;
    } else {
      element.className = icon;
    }

    var vue = params.colDef.cellEditorParams.vue;
    var onClick = params.colDef.cellEditorParams.onClick;
    var row = params.data;
    var api = params.api;
    var columnApi = params.columnApi;

    element.onclick = function(){
      ExpressionUtil.eval(vue, onClick, row, api, columnApi);
    };
    return element;
}
</script>


// WEBPACK FOOTER //
// src/components/pack/GridComponent.vue